const b64url = (bytes) =>
  btoa(String.fromCharCode(...new Uint8Array(bytes)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const randomString = (len = 64) => {
  const arr = new Uint8Array(len);
  crypto.getRandomValues(arr);
  return b64url(arr).slice(0, len);
};

export const REDIRECT_PATH = "/auth/socialpulse/callback";

export async function beginSocialPulseLogin(config) {
  const verifier = randomString(96);
  const state = randomString(32);
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  const challenge = b64url(digest);
  sessionStorage.setItem("sp_pkce_verifier", verifier);
  sessionStorage.setItem("sp_oauth_state", state);
  const redirectUri = window.location.origin + REDIRECT_PATH;
  const params = new URLSearchParams({
    response_type: "code",
    client_id: config.client_id,
    redirect_uri: redirectUri,
    scope: config.scopes || "openid profile email",
    state,
    code_challenge: challenge,
    code_challenge_method: "S256",
  });
  window.location.href = `${config.authorization_endpoint}?${params.toString()}`;
}
